export default __webpack_public_path__ + "static/media/comment-btn.3401ef78.svg";